var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/remirror__preset-core/src/index.ts
var src_exports = {};
__export(src_exports, {
  corePreset: () => corePreset,
  createCoreManager: () => createCoreManager
});
module.exports = __toCommonJS(src_exports);

// packages/remirror__preset-core/src/core-preset.ts
var import_core = require("@remirror/core");
var import_extension_doc = require("@remirror/extension-doc");
var import_extension_events = require("@remirror/extension-events");
var import_extension_gap_cursor = require("@remirror/extension-gap-cursor");
var import_extension_history = require("@remirror/extension-history");
var import_extension_paragraph = require("@remirror/extension-paragraph");
var import_extension_positioner = require("@remirror/extension-positioner");
var import_extension_text = require("@remirror/extension-text");
var defaultOptions = {
  ...import_extension_doc.DocExtension.defaultOptions,
  ...import_extension_paragraph.ParagraphExtension.defaultOptions,
  ...import_extension_history.HistoryExtension.defaultOptions,
  excludeExtensions: []
};
function corePreset(options = {}) {
  options = { ...defaultOptions, ...options };
  const { content, depth, getDispatch, getState, newGroupDelay, excludeExtensions } = options;
  const excludeMap = {};
  for (const name of excludeExtensions ?? []) {
    excludeMap[name] = true;
  }
  const coreExtensions = [];
  if (!excludeMap["history"]) {
    const historyExtension = new import_extension_history.HistoryExtension({ depth, getDispatch, getState, newGroupDelay });
    coreExtensions.push(historyExtension);
  }
  if (!excludeMap["doc"]) {
    coreExtensions.push(new import_extension_doc.DocExtension({ content }));
  }
  if (!excludeMap["text"]) {
    coreExtensions.push(new import_extension_text.TextExtension());
  }
  if (!excludeMap["paragraph"]) {
    coreExtensions.push(new import_extension_paragraph.ParagraphExtension());
  }
  if (!excludeMap["positioner"]) {
    coreExtensions.push(new import_extension_positioner.PositionerExtension());
  }
  if (!excludeMap["gapCursor"]) {
    coreExtensions.push(new import_extension_gap_cursor.GapCursorExtension());
  }
  if (!excludeMap["events"]) {
    coreExtensions.push(new import_extension_events.EventsExtension());
  }
  return coreExtensions;
}
function createCoreManager(extensions, options = {}) {
  const { core, ...managerSettings } = options;
  return import_core.RemirrorManager.create(
    () => [...(0, import_core.getLazyArray)(extensions), ...corePreset(core)],
    managerSettings
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  corePreset,
  createCoreManager
});
